import React from "react";
import { createRoot } from "react-dom/client";
import MemoryStart from "./MemoryStart";
import Memory from "./Memory";
import MemoryLevelContextProvider from "../Context/MemoryLevelContext";
import MemoryCountDownContextProvider from "../Context/MemoryCountDownContext";
import MemoryTimerContextProvider from "../Context/MemoryTimerContext";
import MemorySteps from "./MemorySteps";

export const UmbracoValues = React.createContext();

const MemoryGame = ({ rootElement }) => {
  const umbracoValues = {
    id: rootElement.getAttribute("data-memory-id"),
    descriptionTitle: rootElement.getAttribute("data-memory-title-description"),
    description: rootElement.getAttribute("data-memory-description"),
    image: rootElement.getAttribute("data-memory-image")
  };

  return (
    <div className={`game-container memory`}>
      <MemoryLevelContextProvider umbracoValues={umbracoValues}>
        <MemoryTimerContextProvider>
          <MemoryCountDownContextProvider>
            <UmbracoValues.Provider value={umbracoValues}>
              <MemorySteps />
            </UmbracoValues.Provider>
          </MemoryCountDownContextProvider>
        </MemoryTimerContextProvider>
      </MemoryLevelContextProvider>
    </div>
  );
}

export const renderMemory = () => {
    const rootElements = document.getElementsByClassName('memoryContainer');
    
    if (rootElements.length > 0) {
      Array.from(rootElements).forEach((rootElement) => {
        const root = createRoot(rootElement);
        root.render(<MemoryGame rootElement={rootElement} />);
      });
    }
};
